import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'color-icon-button',
  template: `
    <ng-content></ng-content>
  `,
  styleUrls: ['./color-icon-button.scss'],
  host: {
    class: 'color-icon-button',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorIconButton {}
